/** `channel` values for `GET /statistic/{fi}/statement`. */
export const STATEMENT_CHANNEL = {
  EMAIL: "email",
  DIGITAL: "digital",
  BOTH: "both",
} as const;

export type StatementChannel =
  (typeof STATEMENT_CHANNEL)[keyof typeof STATEMENT_CHANNEL];
